export enum BillType
{
    Acceptance,
    Shipment,
    Placement,
    Package,
    Other
}